import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ContactUsPage.component.css';
import Navbar from '../Common/Navbar';

function ContactUsComponent() {
  const [formData, setFormData] = useState({
    firstName: '',
    userType: '',
    mobile: '',
    email: '',
    message: '',
    captcha: ''
  });

  const [errors, setErrors] = useState({});
  const [captchaText, setCaptchaText] = useState('');

  // Generate Captcha
  const generateCaptcha = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*';
    let captcha = '';
    for (let i = 0; i < 6; i++) {
      captcha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(captcha);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.userType.trim()) newErrors.userType = 'Please select user type';

    if (!formData.mobile.trim()) {
      newErrors.mobile = 'Mobile number is required';
    } else if (!/^\+?[\d\s-]{10,}$/.test(formData.mobile)) {
      newErrors.mobile = 'Invalid mobile number';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email address';
    }

    if (!formData.captcha.trim()) {
      newErrors.captcha = 'Please type the characters';
    } else if (formData.captcha !== captchaText) {
      newErrors.captcha = 'Characters do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const payload = { ...formData, access_key: 'ffe9b71b-4e54-41ed-bb2a-c52a8b9d9ce4' };

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then((r) => r.json());

      if (res.success) {
        alert('✅ Thank you for contacting us! We will get back to you soon.');
        setFormData({
          firstName: '',
          userType: '',
          mobile: '',
          email: '',
          message: '',
          captcha: ''
        });
        generateCaptcha();
      }
    } catch (error) {
      console.error(error);
      alert('❌ Something went wrong. Please try again.');
    }
  };

  return (
    <div className="contact-page">
      <Navbar />

      <div className="container py-5">
        <div className="row g-4 align-items-stretch">



          {/* LEFT INFO CARD */}
          <div className="col-lg-5">
            <div className="card shadow contact-info-card">
              <div className="card-body text-center">
                <h2 className="fw-bold mb-4 text-primary">Get In Touch With Us!</h2>

                <div className="contact-info-section mb-4">
                  <div className="contact-icon-wrapper mb-2">📞</div>
                  <h5>Phone Number</h5>
                  <p className="mb-0">080 4169 2763</p>
                </div>

                <div className="contact-info-section mb-4">
                  <div className="contact-icon-wrapper mb-2">✉️</div>
                  <h5>Email</h5>
                  <p className="mb-0">info@elexyt.com</p>
                </div>

                <hr />

                <div className="contact-info-section">
                  <div className="contact-icon-wrapper mb-2">📍</div>
                  <h5>Location</h5>
                  <p className="mb-0">Bangalore, Karnataka</p>
                </div>
                {/* MAP SECTION */}
                <div className="container mt-4">
                  <div className="map-container mb-4">
                    <iframe
                      title="Elexyt Location"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.888799699379!2d77.59456231524573!3d12.971598690857802!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1670a743b33d%3A0x3d4b38183b081e0!2sBangalore%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1707577812345"
                      width="100%"
                      height="350"
                      style={{ border: 0, borderRadius: "12px" }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* CONTACT FORM */}
          <div className="col-lg-7">
            <form className="card shadow contact-form-card" onSubmit={handleSubmit}>

              <div className="contact-form-header text-center text-white py-3">
                <h3 className="fw-bold mb-0">Contact Us</h3>
              </div>

              <div className="card-body p-4">

                <div className="row mb-3">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <label className="form-label fw-semibold">First Name *</label>
                    <div className="input-group">
                      
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className={`form-control contact-form-input ${errors.firstName ? 'is-invalid' : ''}`}
                        placeholder="Enter your name"
                      />
                    </div>
                    {errors.firstName && <div className="text-danger small mt-1">{errors.firstName}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">User Type *</label>
                    <div className="input-group">
                      <select
                        name="userType"
                        value={formData.userType}
                        onChange={handleChange}
                        className={`form-control contact-form-input ${errors.userType ? 'is-invalid' : ''}`}
                      >
                        <option value="">Select Type</option>
                        <option value="individual">Individual</option>
                        <option value="organisation">Organisation</option>
                      </select>
                    </div>
                    {errors.userType && <div className="text-danger small mt-1">{errors.userType}</div>}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6 mb-3 mb-md-0">
                    <label className="form-label fw-semibold">Mobile Number *</label>
                    <div className="input-group">
                      <input
                        type="text"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        className={`form-control contact-form-input ${errors.mobile ? 'is-invalid' : ''}`}
                        placeholder="Enter your mobile number"
                      />
                    </div>
                    {errors.mobile && <div className="text-danger small mt-1">{errors.mobile}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Email ID *</label>
                    <div className="input-group">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={`form-control contact-form-input ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="Enter your email"
                      />
                    </div>
                    {errors.email && <div className="text-danger small mt-1">{errors.email}</div>}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Message</label>
                  <textarea
                    rows="5"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control contact-message-textarea"
                    placeholder="Write your message..."
                  ></textarea>
                </div>

                <div className="mb-4">
                  <label className="form-label fw-semibold">Please type the characters *</label>

                  <div className="d-flex flex-wrap gap-3 align-items-start">
                    <div className="contact-captcha-box position-relative">
                      {captchaText}
                      <button
                        type="button"
                        onClick={generateCaptcha}
                        className="contact-refresh-captcha"
                      >
                        🔄
                      </button>
                    </div>

                    <div className="flex-grow-1">
                      <input
                        type="text"
                        name="captcha"
                        value={formData.captcha}
                        onChange={handleChange}
                        className={`form-control contact-form-input ${errors.captcha ? 'is-invalid' : ''}`}
                        placeholder="Enter captcha"
                      />
                      {errors.captcha && <div className="text-danger small mt-1">{errors.captcha}</div>}
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button type="submit" className="btn contact-submit-btn px-5 fw-semibold">
                    Submit
                  </button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUsComponent;
